import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

export const FETCH_SHIFT_LOG_ENTRIES = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRIES'
export const FETCH_SHIFT_LOG_ENTRIES_FAILURE = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRIES_FAILURE'
export const FETCH_SHIFT_LOG_ENTRIES_SUCCESS = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRIES_SUCCESS'

export const FETCH_SHIFT_LOG_ENTRY = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRY'
export const FETCH_SHIFT_LOG_ENTRY_FAILURE = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRY_FAILURE'
export const FETCH_SHIFT_LOG_ENTRY_SUCCESS = 'shiftLogEntries/FETCH_SHIFT_LOG_ENTRY_SUCCESS'

export const FETCH_SIGNED_PARTICIPANTS = 'shiftLogEntries/FETCH_SIGNED_PARTICIPANTS'
export const FETCH_SIGNED_PARTICIPANTS_FAILURE = 'shiftLogEntries/FETCH_SIGNED_PARTICIPANTS_FAILURE'
export const FETCH_SIGNED_PARTICIPANTS_SUCCESS = 'shiftLogEntries/FETCH_SIGNED_PARTICIPANTS_SUCCESS'

export const CREATE_SHIFT_LOG_ENTRY = 'shiftLogEntries/CREATE_SHIFT_LOG_ENTRY'
export const CREATE_SHIFT_LOG_ENTRY_FAILURE = 'shiftLogEntries/CREATE_SHIFT_LOG_ENTRY_FAILURE'
export const CREATE_SHIFT_LOG_ENTRY_SUCCESS = 'shiftLogEntries/CREATE_SHIFT_LOG_ENTRY_SUCCESS'

export const UPDATE_SHIFT_LOG_ENTRY = 'shiftLogEntries/UPDATE_SHIFT_LOG_ENTRY'
export const UPDATE_SHIFT_LOG_ENTRY_FAILURE = 'shiftLogEntries/UPDATE_SHIFT_LOG_ENTRY_FAILURE'
export const UPDATE_SHIFT_LOG_ENTRY_SUCCESS = 'shiftLogEntries/UPDATE_SHIFT_LOG_ENTRY_SUCCESS'

export const {
  shiftLogEntries: {
    fetchShiftLogEntry,
    fetchShiftLogEntrySuccess,
    fetchShiftLogEntryFailure,
    fetchShiftLogEntries,
    fetchShiftLogEntriesSuccess,
    fetchShiftLogEntriesFailure,
    fetchSignedParticipants,
    fetchSignedParticipantsSuccess,
    fetchSignedParticipantsFailure,
    createShiftLogEntry,
    createShiftLogEntrySuccess,
    createShiftLogEntryFailure,
    updateShiftLogEntry,
    updateShiftLogEntrySuccess,
    updateShiftLogEntryFailure
  }
} = createActions({
  [FETCH_SHIFT_LOG_ENTRIES]: undefined,
  [FETCH_SHIFT_LOG_ENTRIES_FAILURE]: undefined,
  [FETCH_SHIFT_LOG_ENTRIES_SUCCESS]: undefined,
  [FETCH_SHIFT_LOG_ENTRY]: undefined,
  [FETCH_SHIFT_LOG_ENTRY_FAILURE]: undefined,
  [FETCH_SHIFT_LOG_ENTRY_SUCCESS]: undefined,
  [FETCH_SIGNED_PARTICIPANTS]: undefined,
  [FETCH_SIGNED_PARTICIPANTS_FAILURE]: undefined,
  [FETCH_SIGNED_PARTICIPANTS_SUCCESS]: undefined,
  [CREATE_SHIFT_LOG_ENTRY]: undefined,
  [CREATE_SHIFT_LOG_ENTRY_FAILURE]: undefined,
  [CREATE_SHIFT_LOG_ENTRY_SUCCESS]: undefined,
  [UPDATE_SHIFT_LOG_ENTRY]: undefined,
  [UPDATE_SHIFT_LOG_ENTRY_FAILURE]: undefined,
  [UPDATE_SHIFT_LOG_ENTRY_SUCCESS]: undefined
})

const initialState = {
  clockTypeOptions: [],
  data: [],
  participantsData: [],
  singleShiftLogEntryData: {},
  errorMessage: null,
  hasError: false,
  isLoading: false,
  hasSubmitted: false,
  isSubmitting: false,
  isSuccess: null
}

export default handleActions(
  {
    [FETCH_SHIFT_LOG_ENTRY]: startLoading,
    [FETCH_SHIFT_LOG_ENTRY_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false,
      singleShiftLogEntryData: {}
    }),
    [FETCH_SHIFT_LOG_ENTRY_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      hasSubmitted: false,
      isSuccess: true,
      hasError: false,
      singleShiftLogEntryData: payload
    }),
    [FETCH_SHIFT_LOG_ENTRIES]: startLoading,
    [FETCH_SHIFT_LOG_ENTRIES_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [FETCH_SHIFT_LOG_ENTRIES_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      hasSubmitted: false,
      isSuccess: true,
      hasError: false,
      data: payload
    }),
    [FETCH_SIGNED_PARTICIPANTS]: startLoading,
    [FETCH_SIGNED_PARTICIPANTS_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [FETCH_SIGNED_PARTICIPANTS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      hasSubmitted: false,
      isSuccess: true,
      hasError: false,
      clockTypeOptions: payload.clockTypeOptions,
      participantsData: payload.teamMembers
    }),
    [CREATE_SHIFT_LOG_ENTRY]: startSubmitting,
    [CREATE_SHIFT_LOG_ENTRY_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSubmitting: false,
      isSuccess: false
    }),
    [CREATE_SHIFT_LOG_ENTRY_SUCCESS]: (state, { payload }) => {
      // payload is just the log object: { id, type, participant_id, participant_name, participant_timestamp, status, ... }
      const participantId = payload.participant_id
      const stateData = state.data || []
      const participantEntry = stateData.find(d => d.participant_id === participantId)

      let updatedData
      if (participantEntry) {
        // Participant exists, add the log to their logs array
        updatedData = stateData.map(entry => {
          if (entry.participant_id === participantId) {
            return {
              ...entry,
              logs: [...entry.logs, payload]
            }
          }
          return entry
        })
      } else {
        // New participant, create a new entry
        updatedData = [
          ...stateData,
          {
            participant_id: participantId,
            logs: [payload]
          }
        ]
      }

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        hasSubmitted: true,
        isSuccess: true,
        hasError: false,
        data: updatedData
      }
    },
    [UPDATE_SHIFT_LOG_ENTRY]: startSubmitting,
    [UPDATE_SHIFT_LOG_ENTRY_FAILURE]: loadingError,
    [UPDATE_SHIFT_LOG_ENTRY_SUCCESS]: (state, { payload }) => {
      // payload is the updated log object: { id, type, participant_id, participant_name, participant_timestamp, status, ... }
      const participantId = payload.participant_id

      const updatedData = state.data.map(participant => {
        if (participant.participant_id === participantId) {
          // Update the specific log within this participant's logs array
          return {
            ...participant,
            logs: participant.logs.map(log => (log.id === payload.id ? payload : log))
          }
        }
        return participant
      })

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        hasSubmitted: true,
        isSuccess: true,
        hasError: false,
        data: updatedData
      }
    }
  },
  initialState
)
